import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

import { ACTIVITY_TYPES, ActivityType } from "../../../User/api/services/activities.service";

const ActivitiesTypes = () => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "activity",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentType = (searchParams.get("activity") as ActivityType) || ActivityType.all;

  const handleOnChangeType = (type: ActivityType) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("activity", type);
    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          display: "flex",
          gap: "8px",
          pb: "8px",
        }}
      >
        {ACTIVITY_TYPES.map((type) => (
          <Chip
            key={type}
            label={t(type)}
            component="button"
            variant="outlined"
            clickable
            onClick={() => handleOnChangeType(type)}
            sx={{
              padding: "1px 4px",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              color: currentType === type ? "var(--Green---100, #008B07)" : "var(--Dark---600, #707070)",
              border: currentType === type ? "1px solid var(--Brand-600, #008B07)" : "none",
              background: currentType === type ? "var(--Brand-25, #F6FFF5)" : "transparent",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ActivitiesTypes;

const styles = {
  container: {
    width: "100%",
    overflowX: "auto",
    whiteSpace: "nowrap",
    padding: "0 8px 0",
    mb: "24px",
  },
};
